import React, { useCallback } from 'react'
import { Checkbox } from '@shopify/polaris'

const CheckboxComponent = (props) => {
  const handleChange = useCallback((newValue) => {
    if (props.onChange) props.onChange(props.name, newValue)
  }, [])

  return (
    <Checkbox
      {...props}
      onChange={handleChange}
    />
  )
}

export default CheckboxComponent
